"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ChipInput_1 = __importDefault(require("./ChipInput"));
var remote_1 = __importDefault(require("./remote"));
var reduxFormWrappers_1 = require("./reduxFormWrappers");
exports.ChipInputRemote = remote_1.default(ChipInput_1.default);
exports.default = exports.ChipInputRemote;
exports.FormChipInputRemote = reduxFormWrappers_1.arrayWrapper(exports.ChipInputRemote);
//# sourceMappingURL=ChipinputRemote.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/ChipinputRemote.js
// module id = 2669
// module chunks = 0